/**
 * "Se hela utbudet för din bil hos {säljare}" — the way from one package to the
 * dealer's whole range (P25009-406 AC-2, BR-3).
 *
 * A Hjulprogram publishes only a few packages per car on purpose; the long tail
 * stays on the dealer's own profile. That trade is only honest if every package
 * page carries the way through, with the car it is fitted to travelling along —
 * otherwise the buyer lands on a profile and has to type their registration
 * number again to get back to where they already were.
 *
 * Renders on package listings only. An ordinary tyre or rim listing is a single
 * product, not a curated selection, so it has no "rest of the range" to point
 * at in this sense.
 */
import React from 'react';

import { NamedLink } from '../../components';
import { packagePartsOf } from '../../util/packageBundleCore';

import css from './ListingPage.module.css';

const SectionFullRangeCtaMaybe = props => {
  const { publicData, authorId, authorDisplayName } = props;

  const isPackage = packagePartsOf(publicData || {}).length > 0;
  const make = publicData?.categoryLevel1 || '';
  const model = publicData?.categoryLevel2 || '';

  if (!isPackage || !authorId || !make || !model) return null;

  const seller = authorDisplayName || 'säljaren';

  return (
    <section className={css.fullRangeCta}>
      <p className={css.fullRangeCtaText}>
        Det här är ett av flera paket. Se hela utbudet för din {make} {model} hos {seller}.
      </p>
      <NamedLink
        name="ProfilePage"
        params={{ id: authorId }}
        /* The car travels in the query string and the anchor lands on the
         * module itself, so the builder opens on the same car the buyer was
         * already looking at rather than an empty form. */
        to={{ search: `?make=${encodeURIComponent(make)}&model=${encodeURIComponent(model)}`, hash: '#bygg-ditt-hjul' }}
        className={css.fullRangeCtaLink}
      >
        Bygg ditt hjul hos {seller}
      </NamedLink>
    </section>
  );
};

export default SectionFullRangeCtaMaybe;
